import React from 'react';

const LoadingIndicator = ({ message = "Loading..." }) => {
    return (
        <div className="loading-indicator">
            <div className="loading-spinner"></div>
            <div className="loading-message">{message}</div>
        </div>
    );
};

export default LoadingIndicator;
